import { Article, ArticleErpInfo, WholesalerArticle } from "@tm/models"
import { useMemo } from "react"

export function useHasNoErpAreaIcons(erpInfos: ArticleErpInfo[], articles: Article[], wholesalerArticles?: WholesalerArticle[]) {
    const hasNoErpAreaIcons = useMemo(() => {
        const hasNoErpAreaIconsInArticles = !articles.some((article) =>
            erpInfos.find(
                (e) =>
                    e.key.internalId === article.internalId &&
                    e.state === "success" &&
                    ((e.response.specialIcons && e.response.specialIcons.length !== 0) ||
                        (e.response.graduatedPrices && e.response.graduatedPrices.length !== 0))
            )
        )

        const hasNoErpAreaIconsInWholesalerArticles = !wholesalerArticles?.some((article) =>
            erpInfos.find(
                (e) =>
                    e.request.wholesalerArticleNumber === article.wholesalerArticleNumber &&
                    e.state === "success" &&
                    ((e.response.specialIcons && e.response.specialIcons.length !== 0) ||
                        (e.response.graduatedPrices && e.response.graduatedPrices.length !== 0))
            )
        )

        return hasNoErpAreaIconsInArticles && hasNoErpAreaIconsInWholesalerArticles
    }, [erpInfos, articles, wholesalerArticles])
    return hasNoErpAreaIcons
}
